import { DefaultGroupViewKeys } from "./keys";

export const englishValues = {
  [DefaultGroupViewKeys.normalGroupQuestionReport_downloadAsPDFTooltip]:
    "Download as PDF",
};

export const malayValues = {
  [DefaultGroupViewKeys.normalGroupQuestionReport_downloadAsPDFTooltip]:
    "Muat turun sebagai PDF",
};

export const chineseSimplifiedValues = {
  [DefaultGroupViewKeys.normalGroupQuestionReport_downloadAsPDFTooltip]:
    "下载为PDF",
};

export const chineseTraditionalValues = {
  [DefaultGroupViewKeys.normalGroupQuestionReport_downloadAsPDFTooltip]:
    "下載為PDF",
};
